"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNode = exports.getNodes = void 0;
function getNodes(state, path) {
    if (path.length === 0) {
        return state.blocks;
    }
    return path.reduce((acc, val) => {
        return acc[val].blocks || acc;
    }, state.blocks);
}
exports.getNodes = getNodes;
function getNode(state, path) {
    return path.reduce((acc, val) => {
        return acc.blocks[val];
    }, state);
}
exports.getNode = getNode;
//# sourceMappingURL=getTreeNode.js.map